module.exports = __webpack_public_path__ + "img/header.c338f7ba.png";